import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useFearGreedIndex } from "@/hooks/useFearGreedIndex";

const FearGreedGauge = () => {
  const { data, isLoading, error } = useFearGreedIndex();
  
  const value = data ? parseInt(data.value) : 0;
  const status = data?.value_classification || "Loading...";
  
  const getColor = () => {
    if (value > 75) return "text-green-500";
    if (value > 50) return "text-green-400";
    if (value > 25) return "text-red-400";
    return "text-red-500";
  };

  if (isLoading) {
    return (
      <Card className="p-6 bg-card border-border">
        <h3 className="text-lg font-semibold mb-4">Fear & Greed Index</h3>
        <div className="flex flex-col items-center">
          <Skeleton className="h-16 w-24 mb-2" />
          <Skeleton className="h-6 w-32 mb-4" />
          <Skeleton className="w-full h-2 rounded-full" />
          <Skeleton className="h-4 w-48 mt-2" />
        </div>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className="p-6 bg-card border-border">
        <h3 className="text-lg font-semibold mb-4">Fear & Greed Index</h3>
        <p className="text-sm text-destructive text-center">Failed to load index data</p>
      </Card>
    );
  }

  const bullsPercent = value;
  const bearsPercent = 100 - value;

  return (
    <Card className="p-6 bg-card border-border">
      <h3 className="text-lg font-semibold mb-4">Market Sentiment</h3>
      <div className="flex flex-col items-center">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="text-center">
            <div className="text-3xl font-bold text-green-500">
              {bullsPercent}%
            </div>
            <div className="text-sm text-muted-foreground">Bulls</div>
          </div>
          <div className="text-2xl text-muted-foreground">vs</div>
          <div className="text-center">
            <div className="text-3xl font-bold text-red-500">
              {bearsPercent}%
            </div>
            <div className="text-sm text-muted-foreground">Bears</div>
          </div>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-red-500 via-yellow-500 to-green-500"
            style={{ width: `${value}%` }}
          />
        </div>
        <div className={`text-sm font-semibold mt-2 ${getColor()}`}>
          {status}
        </div>
        <p className="text-xs text-muted-foreground mt-1 text-center">
          Based on Fear & Greed Index
        </p>
      </div>
    </Card>
  );
};

export default FearGreedGauge;
